export default function ServiceScopeSection() {
  const services = [
    {
      icon: 'ri-eye-line',
      title: 'Manufacturing Surveillance',
      description: 'On-site presence during fabrication operations. Verification of manufacturing procedures, dimensional control, and process compliance. Documentation of activities per agreed inspection and test plans.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Material Verification',
      description: 'Review of material certifications, heat traceability records, and mill test reports. Verification of material specifications per ASME Section II, EN 10204, or project requirements. Positive material identification testing witness.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Welding Oversight',
      description: 'Review of welding procedure specifications and welder qualifications. Witness of procedure qualification testing. Verification of welding consumable traceability and storage conditions.',
    },
    {
      icon: 'ri-scan-line',
      title: 'Non-Destructive Testing Witness',
      description: 'Witness of radiographic, ultrasonic, magnetic particle, and liquid penetrant testing. Review of NDT procedures and operator qualifications. Verification of acceptance criteria application per applicable codes.',
    },
  ];

  return (
    <section className="py-28 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-light-section border border-light-border rounded-full mb-6">
            <span className="text-industrial-steel text-xs font-medium tracking-[0.12em] uppercase">
              Service Scope
            </span>
          </div>
          <h2 className="font-serif text-dark-primary text-4xl leading-tight mb-6">
            Technical Surveillance Services
          </h2>
          <p className="text-industrial-steel text-base leading-[1.8] max-w-3xl">
            Arvakon provides independent verification services during manufacturing and fabrication of industrial equipment. Services include documentation review, witness testing, dimensional inspection, and material traceability verification. Activities are conducted per client-approved inspection and test plans.
          </p>
        </div>

        {/* Service Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => (
            <div key={service.title} className="bg-light-section border border-light-border rounded-lg p-8 hover:border-industrial-lighter transition-colors">
              <div className="w-11 h-11 flex items-center justify-center bg-white border border-light-border rounded-lg mb-6">
                <i className={`${service.icon} text-industrial-steel text-xl`}></i>
              </div>
              <h3 className="text-dark-primary text-lg font-semibold mb-4 leading-snug">
                {service.title}
              </h3>
              <p className="text-industrial-steel text-sm leading-[1.75]">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}